const prod = process.env.NODE_ENV === "production";

export const api = prod
  ? "https://api.urne.i-pericles.com"
  : "http://zero.mefyl.net:8001";
export const credentials = prod
  ? "https://credentials.urne.i-pericles.com"
  : "http://zero.mefyl.net:8000";
export const front = prod
  ? "https://urne.i-pericles.com"
  : "http://zero.mefyl.net:8080";
export const version = "75ad1d3";
